import React, { useState } from "react";
import "./TagsInput.css";
import { Chip, TextField } from "@mui/material";

const TagsInput = ({ tags, setTags, maxTags }) => {
    const [newTag, setNewTag] = useState("");

    const handleAddTag = (e) => {
        e.preventDefault();
        if (newTag && !tags.includes(newTag) && tags.length < maxTags) {
            setTags([...tags, newTag]);
            setNewTag("");
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setTags(tags.filter(tag => tag !== tagToRemove));
    };

    return (
        <div className="tags-input-container">
            {tags.length > 0 && (
                <div className="tags-input">
                    {tags.map((tag, index) => (
                        <Chip
                            key={index}
                            size="small"
                            label={tag}
                            onDelete={() => handleRemoveTag(tag)}
                            sx={{
                                margin: "4px",
                                backgroundColor: "#e0e0e0",
                                "&:hover": { backgroundColor: "#d6d6d6" },
                            }}
                        />
                    ))}
                </div>
            )}
            {tags.length < maxTags && (
                <div className="add-tag">
                    <TextField
                        type="text"
                        id="tags"
                        size="small"
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                        onBlur={handleAddTag}
                        placeholder="Add Tag and Press Enter"
                        onKeyDown={(e) => e.key === 'Enter' && handleAddTag(e)}
                        sx={{ width: "100%", }}
                    />
                    <button className="add-tag-btn" onClick={handleAddTag}>+</button>
                </div>

            )}
        </div>
    );
};

export default TagsInput;
